import { useTranslation } from 'react-i18next'
import { Breadcrumbs, Crumb } from '@carsys/ui'
import { useSelector } from 'react-redux'
import { IRootReducerState } from 'state/rootReducer'
import { useLocation } from 'react-router-dom'

export const ProductWarrantyClaimsBreadCrumbs: React.FC<React.ComponentProps<typeof Breadcrumbs>> = ({ ...props }) => {
  const { t } = useTranslation()
  const location = useLocation()
  const caseNumber = useSelector((state: IRootReducerState) => state.productWarrantyClaim?.detail?.caseNumber)
  const isNewPage = location.pathname.endsWith('/new')

  return (
    <Breadcrumbs {...props}>
      <Crumb
        key='crumb-product-warranty-claims'
        data-testid='crumb-product-warranty-claims'
        path='/product-warranty-claims'
        text={t('productWarrantyClaim.warranties')}
      />
      <Crumb
        data-testid='crumb-product-warranty-claims-new'
        key='crumb-product-warranty-claims-new'
        path='/product-warranty-claims/new'
        text={t('productWarrantyClaim.new_warranty_form')}
      />
      {!isNewPage ? (
        <Crumb
          data-testid='crumb-product-warranty-claims-uuid'
          key='crumb-product-warranty-claims-uuid'
          path='/product-warranty-claims/:warrantyUUID'
          text={caseNumber as string}
        />
      ) : null}
    </Breadcrumbs>
  )
}

export default ProductWarrantyClaimsBreadCrumbs
